import * as React from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Sheet from "@mui/joy/Sheet";
import fileContext from "../../context/fileContext";
import FileView from "../../pages/FileViewPage";

export default function OpenFiles({ isOpen, closeDialog }) {
  const context = React.useContext(fileContext);

  return (
    <React.Fragment>
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={isOpen}
        onClose={closeDialog}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Sheet
          variant="outlined"
          sx={{
            width: "96vw",
            height: "96vh",
            borderRadius: "md",
            boxShadow: "lg",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            padding: "1rem",
            overflow: "hidden",
          }}
        >
          <ModalClose variant="solid" sx={{ m: -2 }} />
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "100%",
              gap: "1rem",
            }}
          >
            {Array.from(
              new Map(context.selectedFiles.map((f) => [f.id, f])).values()
            ).map((file) => {
              if (!file?.id) return null;

              const fileInfo = {
                name: file.name,
                size: file.size,
                id: file.id,
                owner: file.owner,
                ownerProfileUrl: file?.profilePic,
                lastUpdate: file?.lastUpdate,
                mimetype: file?.mimetype,
                download_url: file?.downloadUrl ?? file?.download_url,
                downloadUrl: file?.downloadUrl ?? file?.download_url,
                currVersion: file?.currVersion ?? "",
              };

              return (
                <div
                  key={file.id}
                  style={{ width: "50%", height: "100%", overflow: "hidden" }}
                >
                  <FileView fileInfo={fileInfo} closeDrawer={() => {}} />
                </div>
              );
            })}
          </div>
        </Sheet>
      </Modal>
    </React.Fragment>
  );
}
